// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

interface EsgSectors {
  [key: string]: string;
}

const esgSectors: EsgSectors = {
  adult_content: 'Adult Content',
  alcoholic: 'Alcoholic Participation',
  animal_testing: 'Animal Testing',
  //catholic: 'Catholic',
  coal_energy: 'Coal Energy',
  //environmental_reporting: 'Environmental Reporting',
  firearms: 'Firearms',
  fur_leather: 'Fur Leather',
  gambling: 'Gambling',
  gmo: 'GMO',
  human_rights_policy: 'Human Rights Policy',
  military_contract: 'Military Contract',
  nuclear: 'Nuclear',
  palm_oil: 'Palm Oil',
  pesticides: 'Pesticides',
  tobacco: 'Tobacco',
  weapons: 'Weapons',
};

export const esgSectorsFormatter = (sector: string) => esgSectors[sector] || '';
